<template>
  <div class="media-slot">
    <div class="image-files" v-show="imageUrls && imageUrls.length > 0">
      <el-badge :value="imageUrls.length" type="primary" style="margin: 10px 0">
        <el-image
          class="preview-img"
          fit="cover"
          :src="firstImg"
          :preview-src-list="imageUrls"
          :z-index="3000"
        >
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </el-badge>
    </div>
    <div
      class="mp4-files"
      v-show="videoUrls && videoUrls.length > 0"
      @click="openVideo"
    >
      <el-badge
        :value="videoUrls.length"
        type="primary"
        style="margin: 10px 0; position: relative"
      >
        <div class="preview-img"></div>
        <div class="center">
          <i
            class="el-icon-video-play"
            style="transform: scale(1.2); opacity: 0.7; color: #fff"
          ></i>
        </div>
      </el-badge>
    </div>
    <el-dialog
      title="视频播放器"
      :visible.sync="open"
      width="850"
      append-to-body
    >
      <div class="btns">
        <div v-for="(url, index) in videoUrls" :key="index">
          <el-button
            class="btn"
            type="text"
            :disabled="url == videoUrl"
            @click="videoUrl = url"
            >视频{{ index + 1 }}</el-button
          >
        </div>
      </div>
      <VideoPlay
        v-if="open"
        :videoUrl="videoUrl"
        :width="800"
        :height="450"
        :autoplay="true"
        :controls="true"
        :loop="false"
        :muted="false"
        preload="auto"
        :showPlay="true"
        :playWidth="96"
        zoom="cotain"
      />
    </el-dialog>
  </div>
</template>

<script>
import VideoPlay from "@/components/VideoPlayer";
export default {
  name: "mediaSlot",
  props: ["issueUrlStr"],
  components: { VideoPlay },
  data() {
    return {
      videoUrls: [],
      imageUrls: [],
      videoUrl: "",
      open: false,
    };
  },
  watch:{
    issueUrlStr: {
      handler(){
        this.mediaPathHandler();
      },
      immediate: true
    }
  },
  computed: {
    firstImg() {
      if (!this.imageUrls || this.imageUrls.length == 0) {
        return "";
      }
      return this.imageUrls[0] + "?random=" + new Date().getTime();
    },
  },
  methods: {
    openVideo() {
      this.open = true;
      this.videoUrl = this.videoUrls[0];
    },
    mediaPathHandler(){
      this.videoUrls = [];
      this.imageUrls = [];
      this.issueUrlStr.split(",").forEach((ele) => {
        if (ele && ele.length > 0) {
          let fileArr = ele.split(".");
          let suffix = fileArr[fileArr.length - 1];
          if (suffix == "mp4" || suffix == "MP4"||suffix=='3gp'||suffix=='3GP') {
            this.videoUrls.push(ele);
          } else {
            this.imageUrls.push(ele);
          }
        }
      });
    }
  },
};
</script>

<style scoped>
.media-slot {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  box-sizing: border-box;
}
.center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.btns {
  width: 100%;
  display: flex;
  margin-bottom: 5px;
}
.btn {
  margin-right: 10px;
}
.preview-img {
  width: 50px;
  height: 50px;
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #000;
}
</style>
<style lang="sass" scoped>
::v-deep .image-slot
  display: flex
  justify-content: center
  align-items: center
  width: 100%
  height: 100%
  color: #909399
  font-size: 30px
</style>